import logger from '@/utils/logger';
const Office = window.Office;

const regexp = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*/;

export function subscribeOnItemChanged(handler) {
  return Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, handler);
}

export function unsubscribeOnItemChanged(handler) {
  return Office.context.mailbox.removeHandlerAsync(Office.EventType.ItemChanged, handler);
}

export function getSubject() {
  return new Promise((resolve, reject) =>
    Office.context.mailbox.item.subject.getAsync(asyncResult =>
      asyncResult.status === Office.AsyncResultStatus.Failed ? reject(asyncResult.error) : resolve(asyncResult.value)
    )
  );
}

export function applyToCompose({ subject, body, to = [], cc = [], bcc = [] }) {
  const collection = [];
  if (subject && subject.length) {
    collection.push(setField('subject', subject));
  }

  if (body && body.length) {
    collection.push(prependHtmlField('body', body));
  }

  if (Array.isArray(to) && to.length) {
    collection.push(setRecipientField('to', to));
  }
  if (Array.isArray(cc) && cc.length) {
    collection.push(setRecipientField('cc', cc));
  }
  if (Array.isArray(bcc) && bcc.length) {
    collection.push(setRecipientField('bcc', bcc));
  }

  return Promise.all(collection);
}

async function setField(field, value) {
  return new Promise((resolve, reject) =>
    Office.context.mailbox.item[field].setAsync(value, {}, asyncResult =>
      asyncResult.status === Office.AsyncResultStatus.Failed ? reject(asyncResult.error) : resolve(asyncResult)
    )
  );
}
async function prependHtmlField(field, value) {
  return new Promise((resolve, reject) =>
    Office.context.mailbox.item[field].prependAsync(value, { coercionType: Office.CoercionType.Html, asyncContext: {} }, asyncResult =>
      asyncResult.status === Office.AsyncResultStatus.Failed ? reject(asyncResult.error) : resolve(asyncResult)
    )
  );
}

async function setRecipientField(field, collection) {
  return setField(
    field,
    collection
      .map(s => {
        if (!s || !s.length) {
          return;
        }

        const [emailAddress] = s.match(regexp) || [];
        if (!emailAddress) {
          return;
        }

        const displayName = s.replace(emailAddress, '').replace(/(^[\W]+)|"|([\W]+$)/g, '');

        return {
          displayName,
          emailAddress
        };
      })
      .filter(s => !!s)
  );
}

export async function dialog(url) {
  return new Promise((resolve, reject) => {
    Office.context.ui.displayDialogAsync(url, { promptBeforeOpen: false, height: 50, width: 25 }, arg => {
      if (arg.status === 'failed') {
        reject(arg.error);
        return;
      }

      const instance = arg.value;

      instance.addEventHandler(Office.EventType.DialogMessageReceived, arg => {
        try {
          const message = JSON.parse(arg.message);
          if (message.status === 'failed') {
            reject(message.e);
          } else {
            resolve(message.data);
          }
        } catch (e) {
          reject(e);
        } finally {
          instance && instance.close();
        }
      });
      instance.addEventHandler(Office.EventType.DialogEventReceived, arg => {
        switch (arg.error) {
          case 12006:
            resolve(null);
            break;
          default:
            reject();
        }
        instance && instance.close();
      });
    });
  });
}
